import React, {ReactElement} from 'react';
import classNames from 'classnames';

const COLORS = [
  ['#000000', '#464e56', '#5b636a', '#767d84', '#b9bdc5', '#e0e4e9', '#f7f8ff', '#ffffff'],
  ['#72d3ff', '#ad6eff', '#ff80c5', '#ffbd74', '#ffe786', '#64f1d9', '#ff8084', '#79f4bd'],
  ['#2bbcff', '#882dff', '#ff4aad', '#ffa33f', '#ffdb48', '#22dbbc', '#ff333a', '#00b061'],
  ['#0780eb', '#6500e8', '#c70085', '#e5632a', '#efbb00', '#00a19a', '#dc142d', '#009c56'],
  ['#0061cb', '#4300ac', '#970064', '#c73b0a', '#e09c00', '#006c84', '#ae1125', '#00894c'],
];

interface ColorPickerProps {
  className?: string;
  value?: string;
  onChange?: (value: string) => void;
}

export const ColorPicker: React.FunctionComponent<ColorPickerProps> = ({value, onChange}) => {
  return (
    <div className="flex flex-col p-2 bg-white border border-gray">
      {COLORS.map(
        (colorPallete: Array<string>, index: number): ReactElement => (
          <div key={index} className="flex">
            {colorPallete.map(
              (color): ReactElement => (
                <div
                  key={color}
                  className={classNames(
                    'w-6 h-6 border-2 cursor-pointer',
                    color === value ? 'border-selectedColor' : 'border-white'
                  )}
                  onClick={() => onChange && onChange(color)}
                  style={{backgroundColor: color}}
                />
              )
            )}
          </div>
        )
      )}
    </div>
  );
};
